export const SEO = {
  brand: "Takamori Robot",
  primary: "Engineering Kit",
  phrases: [
    "engineering kit",
    "beginner robotics course",
    "robotics for classrooms",
    "education robotics",
    "students robotics",
  ],

  // some common sentences we can use
  valueProps: [
    "Hands-on education robotics for students and makers.",
    "A beginner robotics course experience built into an engineering kit.",
    "Designed for robotics for classrooms and learning at home.",
  ],
};